/**
 * The portrait grid of `/about-us/leadership-team`: every leader, each linking to their profile,
 * with no action tile. The grid renderer is `./Team/ContentfulLeaders.tsx`.
 *
 * Position: rendered only by `./LeadershipTeam.tsx`, below `./LeadershipHeader.tsx`. The section
 * background is a vertical split, 5% `theme.colors.tertiary.background` then 95%
 * `theme.colors.secondary.background`, and `ContentWrapper` pulls the grid up 180px so it
 * overlaps the hero.
 */
import React from "react";
import { ContentSection } from "@ryerson/frontend.layout";
import styled from "@emotion/styled";
import ContentfulLeaders from "@components/Leadership/Team/ContentfulLeaders";
import { useTheme } from "@ryerson/frontend.theme";
import { ProcessedContentfulLeadersFieldsByLanguage } from "@contentful/leader/types";

const ContentWrapper = styled.div`
	margin-top: -180px;
	overflow: hidden;
	margin-bottom: 80px;
`;

interface LeadershipSectionProps {
	/** Leader cards in every language, passed through to `./Team/ContentfulLeaders.tsx`. */
	contentfulLeadershipTeam: ProcessedContentfulLeadersFieldsByLanguage;
}

/** Renders the leadership team page's portrait grid on its split background. */
const LeadershipSection: React.FC<LeadershipSectionProps> = ({ contentfulLeadershipTeam }) => {
	const { theme } = useTheme();
	return (
		<ContentSection
			type="split"
			split={{
				splitDirection: "vertical",
				splitColors: [
					{
						color: theme.colors.tertiary.background,
						percentage: "5%",
					},
					{
						color: theme.colors.secondary.background,
						percentage: "95%",
					},
				],
			}}
		>
			<ContentWrapper>
				<ContentfulLeaders contentfulLeadershipTeam={contentfulLeadershipTeam} />
			</ContentWrapper>
		</ContentSection>
	);
};

export default LeadershipSection;
